import { render } from "./Link.vue?vue&type=template&id=32e8ab1a"
import script from "./Link.vue?vue&type=script&lang=js"
export * from "./Link.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "32e8ab1a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32e8ab1a', script)) {
    api.reload('32e8ab1a', script)
  }
  
  module.hot.accept("./Link.vue?vue&type=template&id=32e8ab1a", () => {
    api.rerender('32e8ab1a', render)
  })

}

script.__file = "src/layout/components/Sidebar/Link.vue"

export default script